"use client"

import { FilePlus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FilePlusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FilePlusIcon = component(Icon)({ as: FilePlus })
